<template>
  <fh-container class="text-center">
    <v-tooltip bottom>
      <template
        v-if="nombre === 'Consulta de Cuentas'"
        v-slot:activator="{ on }"
      >
        <v-btn
          v-on="on"
          href="https://banking.fernheim.com.py/"
          class="secondary mb-6 text-none"
        >
          <img
            width="32px"
            :src="require('@/assets/transf_money.svg')"
            alt="Icono Transferencias Online"
            class="mr-2"
          />
          Transferencias Online
        </v-btn>
      </template>
      <span>Solicite el servicio en el </span>
      <span>Departamento de Finanzas</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template
        v-if="nombre === 'Consulta de Cuentas'"
        v-slot:activator="{ on }"
      >
        <v-btn
          v-on="on"
          href="https://consultafacturas.fernheim.com.py/"
          class="ml-2 secondary mb-6 text-none"
        >
          <v-icon class="pr-2" size="25">request_page</v-icon>
          Facturas Fernheim
        </v-btn>
      </template>
      <span>Solicite el servicio en el </span>
      <span>Departamento de Contabilidad</span>
    </v-tooltip>
    <fh-title>{{ nombre || title }}</fh-title>

    <fh-card>
      <div class="headline text-center mb-2">Iniciar Sesión</div>
      <v-container fluid>
        <v-row justify="center">
          <v-col lg="12" md="12" sm="12" cols="12">
            <v-form ref="loginForm" v-model="valid" lazy-validation>
              <v-row justify="center">
                <v-col lg="11" sm="11" md="11" cols="11">
                  <v-text-field
                    :rules="codigoAccesoRules"
                    @keyup.enter="handleLogin"
                    autofocus
                    label="Cuenta"
                    @focus="setFocusCodigo"
                    v-model="codigoAcceso"
                    autocomplete="username"
                    type="number"
                    inputmode="numeric"
                    ref="cuenta"
                  ></v-text-field>

                  <v-text-field
                    :rules="pinRules"
                    @keyup.enter="handleLogin"
                    label="Pin"
                    @focus="setFocusPin"
                    :append-icon="showPin ? 'visibility' : 'visibility_off'"
                    :type="showPin ? 'text' : 'password'"
                    inputmode="numeric"
                    @click:append="showPin = !showPin"
                    v-model="pin"
                    autocomplete="current-password"
                    ref="pin"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-container class="hidden-xs-only">
                <v-row justify="center" no-gutters>
                  <v-col cols="4">
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(1)"
                    >
                      1
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(2)"
                    >
                      2
                    </v-btn>
                  </v-col>
                  <v-col cols="4" md="4">
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(3)"
                    >
                      3
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row justify="center" no-gutters class="mt-2">
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(4)"
                    >
                      4
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(5)"
                    >
                      5
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(6)"
                    >
                      6
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row justify="center" no-gutters class="mt-2">
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(7)"
                    >
                      7
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(8)"
                    >
                      8
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(9)"
                    >
                      9
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row justify="center" no-gutters class="mt-2">
                  <v-col>
                    <v-btn
                      class="text-none px-0"
                      width="1"
                      elevation="1"
                      @click="seleccionar(10)"
                    >
                      Borrar
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="text-none"
                      width="1"
                      elevation="1"
                      @click="seleccionar(0)"
                    >
                      0
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="text-none px-0"
                      width="1"
                      elevation="1"
                      @click="seleccionar(11)"
                    >
                      Entrar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>

              <v-row justify="center">
                <v-btn
                  @click="seleccionar(11)"
                  elevation="1"
                  class="my-1 text-none d-flex d-sm-none"
                >
                  Entrar
                </v-btn>
              </v-row>

              <v-row justify="center">
                <v-col cols="11">
                  Solicite su PIN en el Departamento de Ahorro y Crédito.
                  <router-link :to="requestResetPinLink" exact>
                    ¿Olvidó su pin?
                  </router-link>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from "@/components/FhContainer";
import FhTitle from "@/components/FhTitle";
import FhCard from "@/components/FhCard";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { extractHostname, redirect } from "@/utils";
import { IDENTIFICACIONPIN_DOMAIN } from "@/config";
// import transfMoneySvg from '@/assets/transf_money.svg'

export default {
  name: "Login",
  components: { FhCard, FhTitle, FhContainer },
  data() {
    return {
      title: "Socio Fernheim",
      valid: true,
      showPin: false,
      // Defer validation until first submit attempt
      isSubmit: false,
      codigoAcceso: "",
      codigoAccesoRules: [
        (v) => !this.isSubmit || !!v || "Campo obligatorio",
        (v) => !this.isSubmit || this.validateCodigoAcceso(v),
      ],
      pin: "",
      pinRules: [(v) => !this.isSubmit || !!v || "Campo obligatorio"],
      focusCodigo: null,
      focusPin: null,
    };
  },
  computed: {
    ...mapState("auth", ["debeCambiarPin"]),
    query() {
      return this.$route.query;
    },
    hostname() {
      return extractHostname(this.query);
    },
    nombre() {
      if (!_.isEmpty(this.query) && this.query.nombre) {
        return this.query.nombre;
      } else {
        return null;
      }
    },
    requestResetPinLink() {
      if (!!this.query.nombre && !!this.query.redirect) {
        return {
          name: "RequestResetPin",
          query: { nombre: this.query.nombre, redirect: this.query.redirect },
        };
      } else {
        return { name: "RequestResetPin" };
      }
    },
  },
  methods: {
    ...mapActions("auth", ["login", "unsetCookie", "unsetAuth"]),
    ...mapActions("snackbar", ["showSnackbar"]),
    setFocusCodigo() {
      this.focusCodigo = true;
      this.focusPin = false;
    },
    setFocusPin() {
      this.focusCodigo = false;
      this.focusPin = true;
    },
    seleccionar(id) {
      if (this.focusCodigo) {
        if (id < 10) {
          this.codigoAcceso = `${this.codigoAcceso}${id}`;
        } else if (id === 10) {
          this.clearCodigoAcceso();
        } else if (id === 11) {
          this.handleLogin();
        }
      } else if (this.focusPin) {
        if (id < 10) {
          this.pin = `${this.pin}${id}`;
        } else if (id === 10) {
          this.clearPin();
        } else if (id === 11) {
          this.handleLogin();
        }
      }
    },
    clearCodigoAcceso() {
      this.codigoAcceso = "";
    },
    clearPin() {
      this.pin = "";
    },
    async handleLogin() {
      if (this.pin === "" && !this.focusPin) {
        this.$refs["pin"].focus();
        return;
      } else if (this.codigoAcceso === "" && !this.focusCodigo) {
        this.$refs["cuenta"].focus();
        return;
      }
      this.isSubmit = true;
      if (this.$refs.loginForm.validate()) {
        try {
          let codigoAccesoInt = parseInt(this.codigoAcceso, 10);
          if (
            codigoAccesoInt > 2147483647 ||
            isNaN(codigoAccesoInt) ||
            codigoAccesoInt === null ||
            typeof codigoAccesoInt === "string"
          ) {
            this.showSnackbar([
              "Error inesperado. Vuelva a intentar más tarde.",
            ]);
            return;
          }
          await this.login([
            codigoAccesoInt,
            this.pin,
            this.hostname || IDENTIFICACIONPIN_DOMAIN,
          ]);

          if (this.debeCambiarPin) {
            this.$router.push({
              name: "ChangePin",
              query: this.query,
            });
            return;
          }

          redirect(this.query, this.$router);
        } catch (e) {
          //
        }
      }
    },
    validateCodigoAcceso(codigoAcceso) {
      if (codigoAcceso.length < 4 || codigoAcceso.length > 10) {
        return "Número de cuenta inválido";
      }

      let codigoAccesoInt = parseInt(codigoAcceso);
      if (
        codigoAccesoInt > 2147483647 ||
        isNaN(codigoAccesoInt) ||
        codigoAccesoInt === null
      ) {
        return "Número de cuenta inválido";
      }

      return true;
    },
  },
  mounted() {
    this.unsetCookie();
    this.unsetAuth();
  },
};
</script>

<style scoped>
</style>
